module.exports = __webpack_public_path__ + "fonts/iOS_60x60.36c4fad2e2929cfed4915137dbac684d.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/iOS_60x60.png
// module id = 764
// module chunks = 9